/** @format */

export type initEntrySessionDataType = {
  entry_infos: {
    entry_id: number;
    register_at: string | null;
    status: string;
    shop_name: string | null;
    shop_website_url: string | null;
    account_id: string | null;
    plan_name: string;
  }[];
};

export const initEntrySessionData: initEntrySessionDataType = {
  entry_infos: [],
};
